// Components
import { Loading } from "components"
import { FormSectionReceiveMoney, Print } from "./components"

// Contexts
import { ListJournalProvider } from "../contexts"

// Form
import { FormProvider, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"

// Third-Party Libraries
import toast from "react-hot-toast"
import { useParams, useNavigate } from "react-router"

// Utils
import { useApi, usePermission } from "utils"
import { getAcc, useDetail } from "../utils"
import { FormEditType, formParams, getFinalValue, validationSchemaEdit } from "./utils"
import { PERMISION } from "security"

export default function EditReceiveMoney() {
  // Hooks
  const { data_source, data_source_id } = useParams()
  const { data, isLoading } = useDetail(data_source!, data_source_id!)

  if (isLoading || !data) {
    return <Loading loading={isLoading} errorText="No Data Available" />
  }

  return <DataSection data={data} />
}

function DataSection(params: { data: FormEditType }) {
  // Hooks
  const api = useApi()
  const navigate = useNavigate()
  const permission = usePermission([PERMISION.FINANCE.TRANSACTION.RECEIVE_MONEY.PERMISION])

  // Form  
  const methods = useForm<FormEditType>({
    defaultValues: params.data,
    resolver: yupResolver(validationSchemaEdit)
  })
  const onSubmit = (value: FormEditType) => {
    // Hooks
    const { sub_total, tax } = getAcc(value.datajournal)

    return new Promise<void>((resolve) => {
      if (Math.abs(value.amount - (sub_total + tax)) !== 0) {
        toast.error("Balance must be 0")
        return resolve()
      }
      toast.promise(
        api.put("/receivemoney/update", {
          financeid: value.financeid,
          journal_code: value.journal_code,
          ...getFinalValue(value)
        }),
        {
          loading: "Loading...",
          success: (res) => res.data.message,
          error: (err) => err.response.data.detail?.message ?? err.response.data.message
        }
      ).then(() => {
        navigate("/finance/journal")
      }).catch(() => {}).finally(resolve)
    })
  }

  return (
    <FormProvider {...methods}>
      <ListJournalProvider
        is_enabled
        data_source={formParams.dataSource}
        date={params.data.transaction_date}
        journal_code={params.data.journal_code}
      >
        <FormSectionReceiveMoney
          isEdit
          {...formParams}
          onSubmit={methods.handleSubmit(onSubmit)}
          permission={permission}
          print={<Print />}
        />
      </ListJournalProvider>
    </FormProvider>
  )
}